const ConcatUnitInUrl = (url) => `${url}?unidade=${window.localStorage.getItem('w-acronym')}`;

export default ConcatUnitInUrl;
